module.exports = __webpack_public_path__ + "media/Celebration of Winner.f60caa20.mp3";